import React, { useState } from 'react';
import { Pie, Bar, Line } from 'react-chartjs-2';
import CardListView from "./CardListView";

const TableView = ({ data }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 20;
  const totalPages = Math.ceil(data.length / rowsPerPage);

  const handleNext = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));
  const handlePrev = () => setCurrentPage(prev => Math.max(prev - 1, 1));

  const currentData = data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  if (!data || data.length === 0) return <div style={{ textAlign: "center" }}>No data available</div>;

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <table className="table table-sm mb-0">
        <tbody>
          {currentData.map((row, idx) => (
            <tr key={idx}>
              {Object.values(row).map((val, i) => (
                <td key={i} dangerouslySetInnerHTML={{ __html: val }}></td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {totalPages > 1 && (
        <div style={{ textAlign: 'center', marginTop: '10px' }}>
          <button className="btn btn-sm btn-secondary mx-1" onClick={handlePrev} disabled={currentPage === 1}>Prev</button>
          <span>Page {currentPage} of {totalPages}</span>
          <button className="btn btn-sm btn-secondary mx-1" onClick={handleNext} disabled={currentPage === totalPages}>Next</button>
        </div>
      )}
    </div>
  );
};

const ChartComponent = ({ array1, chartType, colorScheme, handleDivClick, divNum, chartStyles, reportName, onLeadModalClose }) => {
  const renderCustomLegend = (dataArray, colorScheme) => {
    return (

      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '10px' }}>

        {dataArray.map((item, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
            <span style={{
              width: '12px',
              height: '12px',
              backgroundColor: colorScheme[index % colorScheme.length],
              display: 'inline-block',
              marginRight: '5px',
            }}></span>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    );
  };

  const renderChartOrTable = (type, colorScheme, dataArray) => {
    if (!dataArray || dataArray.length === 0) return <div style={{textAlign:"center"}}>No data available</div>;

    // Table view

    if (type === 'Table') return <CardListView data={dataArray} onLeadModalClose={onLeadModalClose} />;
    ;
    // Chart view

    const chartData = {
      labels: dataArray.map(item => item.label),
      datasets: [
        {
          label: 'Data',
          data: dataArray.map(item => item.value),
          backgroundColor: colorScheme.map((color, index) => colorScheme[index % colorScheme.length]),
        },
      ],
    };

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: { legend: { display: false } },
      scales: {},
    };

    return (
      <>
        {renderCustomLegend(dataArray, chartData.datasets[0].backgroundColor)}
        <div style={{ width: '100%', height: '200px' }}>
          {type === 'Bar' && <Bar data={chartData} options={chartOptions} height={200} width={300} />}
          {type === 'Pie' && <Pie data={chartData} options={chartOptions} height={200} width={300} />}
          {type === 'Line' && <Line data={chartData} options={chartOptions} height={200} width={300} />}
        </div>
      </>
    );
  };

  return (
    <div className="col-sm-12 mb-3">

      <div
        style={{
          border: '1px solid #ddd',
          padding: '10px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          height: '500px'
        }}
      >
        {/* Fixed title */}
        <h5 style={{ marginBottom: '10px', textAlign: 'center' }}>
          {reportName || 'No Report Selected'}
        </h5>

        {/* Scrollable content */}
        <div style={{ flex: 1, width: '100%', overflowY: chartType === 'Table' ? 'auto' : 'hidden' }}>
          <button
            style={{
              position: "absolute",
              zIndex: 10,
              background: "none",
              border: "none",
              marginLeft:"10px"
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleDivClick(divNum);
            }}
          >
            <img style={{ width: "18px", height: "18px" }} title="Search" src="assets/img/resources/setting.JPG" alt="Add icon" />
          </button>
          {renderChartOrTable(chartType, colorScheme, array1)}
        </div>
      </div>
    </div>
  );
};

export default ChartComponent;
